/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, { useEffect } from "react";
import { Redirect, Switch, Route, useHistory } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { Layout } from "../_metronic/layout";
import BasePage from "./BasePage";
import { Logout, AuthPage } from "./modules/Auth";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import Unauthorize from "./modules/Auth/pages/unauthorize";

export function Routes() {
  const history = useHistory();

  const { isAuthorized } = useSelector(
    (state) => ({
      isAuthorized: state.auth.user != null,
    }),
    shallowEqual
  );

  // useEffect(() => {
  //   if (isAuthorized) {
  //     history.push("/dashboard");
  //   } else {
  //     history.push("/auth/login");
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isAuthorized]);

  return (
    <Switch>
      {!isAuthorized ? (
        /*Render auth page when user at `/auth` and not authorized.*/
        <Route>
          <AuthPage />
        </Route>
      ) : (
        /*Otherwise redirect to root page (`/`)*/
        <Redirect from="/auth" to="/dashboard" />
      )}
      <Route path="/error" component={ErrorsPage} />
      <Route path="/logout" component={Logout} />
      {process.env.NODE_ENV !== "production" && !isAuthorized && (
        /*Redirect to `/auth` when user is not authorized*/
        <Redirect to="/auth/login" />
      )}
      <Route path="/unauthorize" component={Unauthorize} />

      {isAuthorized ? (
        <Layout>
          <BasePage />
        </Layout>
      ) : (
        <Redirect to="/unauthorize" />
      )}
    </Switch>
  );
}
